'use client';

import { Search, Menu } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { SpaceSwitcher } from '@/components/space-switcher';
import { NotificationBell } from '@/components/notification-bell';
import { UserDropdown } from '@/components/user-dropdown';
import { useSidebar } from '@/components/ui/sidebar';

export function TopBar() {
  const { setOpenMobile } = useSidebar();

  return (
    <div className="flex h-12 items-center justify-between gap-2 px-2 sm:px-4 bg-muted shrink-0">
      <div className="flex items-center gap-2 shrink-0">
        <Button
          variant="ghost"
          size="icon"
          className="h-8 w-8 lg:hidden"
          onClick={() => setOpenMobile(true)}
        >
          <Menu className="h-5 w-5" />
        </Button>
        <SpaceSwitcher />
      </div>

      <div className="flex-1 max-w-md min-w-0 hidden sm:block">
        <div className="relative">
          <Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" />
          <Input
            placeholder="Search..."
            className="pl-10 h-8 bg-muted/50 border-0 w-full"
          />
        </div>
      </div>

      <div className="flex items-center gap-1 sm:gap-2 shrink-0">
        <NotificationBell />
        <UserDropdown variant="compact" />
      </div>
    </div>
  );
}
